module.exports = __webpack_public_path__ + "img/girl-notik.fa033450.jpg";